import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CSWhyPrefer() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-667">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-668">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-669">
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-670">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-671">
              <img src="https://cdn.magicpatterns.com/uploads/bcjgeMwBom7s1ZCmmvMsRU/clearsilk-standout.jpg" alt="ClearSilk Laser Consultation" className="w-full h-full object-cover" data-id="element-672" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-673">
            <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-674">
              Be FIERCE
            </span>

            <h2 className="text-[24px] lg:text-[36px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-675">
              WHY WE PREFER CLEARSILK BY SCITON
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-676"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-677">
              <p data-id="element-678">
                ClearSilk by Sciton is at the forefront of modern aesthetic
                procedures, offering a diverse range of advanced treatments
                utilizing cutting-edge laser and light systems.
              </p>
              <p data-id="element-679">
                At Be CLINICAL, our commitment to excellence in skincare aligns
                perfectly with the innovative solutions provided by Sciton
                technology. With Sciton's versatile and precise devices like
                ClearSilk, we can deliver a wide range of skin rejuvenation and
                corrective procedures that cater to our patients' unique needs
                and goals.
              </p>
              <p data-id="element-680">
                Whether it's laser hair removal, skin tightening or fractional
                laser therapy, Sciton technology enables us to offer safe,
                effective and tailored treatments that deliver remarkable
                results. Sciton's reputation for efficacy and reliability
                resonates with our mission to provide the highest quality
                skincare solutions. Together with Sciton technology, we uphold
                our commitment to excellence and continue to exceed our clients'
                expectations in delivering exceptional aesthetic results.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}